<section>

    <div class="page page-dashboard">
        <div class="pageheader">
            <h2>Language List</h2>
            <div class="page-bar">


            </div>
        </div>

        <div class="pagecontent">
            <div class="row">
                <div class="col-sm-12">
                    <div class="panel panel-default">
                        <div class="panel-body lang-list">

                            <a  [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/general']">
                                <button class="btn btn-dark-beige btn-lg" type="button">
                                    <i class="fa fa-building-o" aria-hidden="true" style="font-size: 60px;"></i>

                                    <br>
                                    <span>General</span><br>

                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/deadline']" >
                                <button class="btn btn-teal btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_3.png">
                                    <br>
                                    <span>Deadlines</span><br>
                                </button>
                            </a>


                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/services']">
                                <button class="btn btn-primary btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_5.png">
                                    <br>
                                    <span>Services</span><br>
                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/human_resource']">
                                <button class="btn btn-teal btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_9.png">
                                    <br>
                                    <span>Human Resource</span><br>
                                </button>
                            </a>


                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/measurement_tools']">
                                <button class="btn btn-dark-beige btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_7.png"><br>
                                    <span>Measurement tools </span><br>

                                </button>
                            </a>
                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/problem_solving']">
                                <button class="btn btn-blue btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_6.png"><br>

                                    <span>Problem solving</span><br>

                                </button>
                            </a>
                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/document_management']">
                                <button class="btn btn-teal btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_2.png">
                                    <br>
                                    <span>Document Management </span><br>
                                </button>
                            </a>


                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/customers']">
                                <button class="btn btn-green btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_4.png">
                                    <br>
                                    <span>Customers</span><br>
                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/consultancy']">
                                <button class="btn btn-dark-beige btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_8.png">
                                    <br>
                                    <span>Consultancy</span><br>
                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/academy']">
                                <button class="btn btn-blue btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_11.png">
                                    <br>
                                    <span>Academy</span><br>
                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/project']">
                                <button class="btn btn-teal btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_10.png">
                                    <br>
                                    <span>Project</span><br>
                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/audit']">
                                <button class="btn btn-green btn-lg" type="button">
                                    <img
                                        src="https://www.kaizencloud.eu/kaizencloud_new//assets/kaizen_icon_sidebar/icon_12.png">
                                    <br>
                                    <span>Audit</span><br>
                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/my_profile']">
                                <button class="btn btn-blue btn-lg" type="button">
                                    <i class="fa fa-user" aria-hidden="true" style="font-size: 65px;"></i>
                                    <br>
                                    <span>My Profile</span><br>
                                </button>
                            </a>

                            <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG+'/privacy']">
                                <button class="btn btn-blue btn-lg" type="button">
                                    <i class="fa fa-file" aria-hidden="true" style="font-size: 65px;"></i>
                                    <br>
                                    <span>Privacy</span><br>
                                </button>
                            </a>                            




                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</section>